export function formatSeconds(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    if (seconds === 0) {
        return "--";
    }

    if (remainingSeconds === 0) {
        return `${String(minutes).padStart(2, "0")} min`;
    }

    if (minutes === 0) {
        return `${String(remainingSeconds).padStart(2, "0")} sec`;
    }

    return `${String(minutes).padStart(2, "0")} min ${String(remainingSeconds).padStart(2, "0")} sec`;
}

export const getDefaultWeekRange = () => {
    const today = new Date();
    const dayOfWeek = today.getUTCDay();

    const firstDay = new Date(today);
    firstDay.setUTCDate(today.getUTCDate() - dayOfWeek);

    const lastDay = new Date(today);
    lastDay.setUTCDate(today.getUTCDate() + (6 - dayOfWeek));

    return {
        firstdayDefault: firstDay.toUTCString(),
        lastdayDefault: lastDay.toUTCString(),
    };
};